import request from "@/utils/request"

export function login(params) {
    return request.post(
        '/user/oauth/token', null, {
            params
        }
    )
}
